import { useHistory } from "react-router-dom";

import { refreshUserAuth } from "@api";
import { withToaster } from "@utils";

import { createParentOrg } from "@pages/settings/api";

export const useCreateOrganization = () => {
  const history = useHistory();

  const createOrganization = async (organization_id: string) => {
    await withToaster(
      async () => {
        await createParentOrg(organization_id);
        await refreshUserAuth();
        history.go(0);
      },
      async (err) => {
        if (
          err.body?.error?.includes(
            "Organization already exists for this deployment"
          )
        ) {
          await refreshUserAuth();
          history.go(0);
          return;
        }
        return `Failed to create parent organization: ${err.body?.error}`;
      }
    )();
  };
  return { createOrganization };
};
